import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import Dashboard from './Dashboard';
import Calendar from './Calendar';
import Trans from './Trans';
import TransactionDetail from './TransactionDetail';
import ReportInvoice from './ReportInvoice';
import ReportInvoiceFull from './ReportInvoiceFull';
import Refund from './Refund';
import CheckPayout from './CheckPayout';
import ApprovePayout from './ApprovePayout';
import ReportPayout from './ReportPayout';
import ReportPayment from './ReportPayment';
import Merchant from './Merchant';
import MerchantPerformance from './MerchantPerformance';
import AuditLog from './AuditLog';
import CekgudangCompanies from './CekgudangCompanies';

const fourtOFour = () => <section className="ops-page"><div className="ops-state"><i className="fas fa-map-signs" /><h3>Halaman tidak ditemukan</h3><p>Alamat yang Anda buka tidak tersedia di SPIN Management Portal.</p></div></section>

class Routes extends React.Component {
  render() {
    return (
      <Switch>
        <Route path='/dashboard' exact component={Dashboard} />
        <Route path='/merchant' exact component={Merchant} />
        <Route path='/merchant/performance' exact component={MerchantPerformance} />
        <Route path='/audit-log' exact component={AuditLog} />
        <Route path='/cekgudang/companies' exact component={CekgudangCompanies} />
        <Redirect from='/transaction_1' exact to='/transaction' />
        <Route path='/transaction' exact component={Trans} />
        <Route path='/transactiondetail/:invoiceId' exact component={TransactionDetail} />
        <Route path='/reportinvoice' exact component={ReportInvoice} />
        <Route path='/reportinvoicefull' exact component={ReportInvoiceFull} />
        <Route path='/refund' exact component={Refund} />
        <Route path='/checkpayout' exact component={CheckPayout} />
        <Route path='/approvepayout' exact component={ApprovePayout} />
        <Route path='/reportpayout' exact component={ReportPayout} />
        <Route path='/reportpembayaran' exact component={ReportPayment} />
        <Route path='/calendar' exact component={Calendar} />

        {/* <Route path='/transaction' exact component={Transaction} /> */}
        <Route component={fourtOFour} />
      </Switch>
    );
  }
}

export default Routes;
